<template>
  <div
    v-if="data && eventToDisplay"
    v-observe-visibility="visibilityChanged"
    :class="[{ 'show-up': isVisible }, baseAnimation]"
    class="module module-single-event padding_large"
  >
    <ModuleContainer>
      <header class="module-heading-linked">
        <ModuleHeading>{{ data.title }}</ModuleHeading>
        <ArchiveLink type="events">Se alle arrangementer</ArchiveLink>
      </header>
      <SingleEvent :id="eventToDisplay" />
    </ModuleContainer>
  </div>
</template>

<script>
import SingleEvent from "@/components/blocks/SingleEvent";
import ArchiveLink from "@/components/elements/ArchiveLink";
import _orderby from "lodash.orderby";

import { mapGetters } from "vuex";
import { isPastEvent } from "@/plugins/helpers";

export default {
  name: "single-event",
  props: {
    data: Object,
    exclude: {
      type: Number,
      default: 0
    },
    hidePast: {
      type: Boolean,
      default: false
    },
    //next icomming, to show next incoming event
    incoming: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters(["getEvents", "isPageLoaded"]),
    eventToDisplay() {
      let eventID = null;
      let events = null;
      if (this.incoming) {
        events = this.getEvents(false, false);
        console.log(events);
      } else {
        events = this.hidePast
          ? this.getEvents(this.data.select_category, false)
          : this.getEvents(this.data.select_category);
      }
      let exclude = this.exclude ? this.exclude : 0;

      //exclude current
      events = !(events && events.length > 0)
        ? null
        : events.filter(it => {
            return it.id !== this.currentPage.id && it.id !== exclude;
          });

      // just grab next evetn
      if (events && events.length > 0) {
        events = _orderby(events, "start_date", "asc");
        eventID = events[0].id;
      }

      return eventID;
    }
  },
  components: {
    SingleEvent,
    ArchiveLink
  }
};
</script>
